import React from "react";
import { Form, Col } from "react-bootstrap";
import { AutoComplete } from "./AutoComplete";
import { _t, i18n } from "../../../app/i18n/i18n";
import { getParam } from "pages/search/api/filterUrlMaker";
import { _c, getTagsFromURL, getTagsFromURLServer } from "./util";
import autoCompleteOptions from "./autoCompleteConfig.json";

export const AnalystCompany = () => (
  <section>
    <Form.Group as={Form.Row} controlId="analyst" className="mb-1">
      <Form.Label column sm="2" className="pb-0">
        {_t("Analyst")}
      </Form.Label>
      <Col sm="5">
        <AutoComplete
          filter="analyst"
          placeholder="Analyst name here ..."
          initialTags={getTagsFromURLServer("Analyst")}
          name="analyst"
          isServer={true}
          datafield="Analyst"
        />
      </Col>
    </Form.Group>

    <Form.Group as={Form.Row} controlId="company" className="mb-1">
      <Form.Label column sm="2">
        {_t("Company or Ticker")}
      </Form.Label>
      <Col sm="5">
        <AutoComplete
          filter="company"
          placeholder="Company name or ticker here..."
          initialTags={getTagsFromURLServer("Company")}
          name="company"
          isServer={true}
          datafield="Company"
        />
      </Col>
    </Form.Group>

    <Form.Group as={Form.Row} controlId="regions" className="mb-1">
      <Form.Label column sm="2" className="pb-0">
        {_t("Regions")}
      </Form.Label>
      <Col sm="5">
        <Form.Check
          type="checkbox"
          label={_t("Japan")}
          name="regions"
          id="japan"
          defaultChecked={!getParam(_c("Regions")) || getParam(_c("Regions")).includes(_t("Japan"))}
          inline
          datainputtype="check"
          datafield="Regions"
          datavalue={_t("Japan")}
        />
        <Form.Check
          type="checkbox"
          label={_t("Asia ex-Japan")}
          name="regions"
          id="aej"
          defaultChecked={!getParam(_c("Regions")) || getParam(_c("Regions")).includes(_t("Asia ex-Japan"))}
          inline
          datainputtype="check"
          datafield="Regions"
          datavalue={_t("Asia ex-Japan")}
        />
        <Form.Check
          type="checkbox"
          label={_t("EMEA")}
          name="regions"
          id="emea"
          defaultChecked={!getParam(_c("Regions")) || getParam(_c("Regions")).includes(_t("EMEA"))}
          inline
          datainputtype="check"
          datafield="Regions"
          datavalue={_t("EMEA")}
        />
        <Form.Check
          type="checkbox"
          label={_t("US")}
          name="regions"
          id="us"
          defaultChecked={!getParam(_c("Regions")) || getParam(_c("Regions")).includes(_t("Americas"))}
          inline
          datainputtype="check"
          datafield="Regions"
          datavalue={_t("Americas")}
        />
      </Col>
    </Form.Group>

    <Form.Group as={Form.Row} controlId="country" className="mb-1">
      <Form.Label column sm="2" className="pb-0">
        {_t("Country")}
      </Form.Label>
      <Col sm="5">
        <AutoComplete
          filter="country"
          placeholder="Country name here..."
          initialTags={getTagsFromURLServer("Country")}
          name="country"
          isServer={true}
          datafield="Country"
        />
      </Col>
    </Form.Group>

    <Form.Group as={Form.Row} controlId="industry" className="mb-1">
      <Form.Label column sm="2" className="pb-0">
        {_t("GICS Industry")}
      </Form.Label>
      <Col sm="5">
        <AutoComplete
          initialTags={getTagsFromURL(_c("Sectors"), autoCompleteOptions["GICSSectors_" + i18n.getLanguage()])}
          name="sectors"
          datafield="Sectors"
          placeholder="Industry name here..."
          options={autoCompleteOptions["GICSSectors_" + i18n.getLanguage()]}
        />
      </Col>
    </Form.Group>
  </section>
);
